import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCookie } from 'utils/cookies';

/** 토큰이 존재하는지 체크하여, 없을 경우 로그인 페이지로 리다이렉션 시키는 hook */
const useCheckToken = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const token = getCookie('imms_access_token');

	useEffect(() => {
		if (!location.pathname.includes('/login') && !token)
			navigate('/imms/login', { replace: true });
	}, [token, location]);
};

export default useCheckToken;
